import {
  defaultFontSetting,
  defaultPaddingSetting,
  defaultBorderRadiusSetting,
  defaultBoxShadowSetting,
  defaultBorderSetting,
  defaultBackgroundSetting,
  defaultIconSetting
} from '../setting/defaultSetting'
export const props = [
  {
    name: "navPopPosition",
    desc: "位置",
    group: "默认",
    categoryName: "导航",
    type: "sliderSet",
    defaultValue: 'left',
    extraConfig: {
      sliderTitle: '对齐',
      showToolTip: true,
      options: [{
        iconClass: 'icon-portal-Align-left',
        label: '左对齐',
        value: 'left'
      }, {
        iconClass: 'icon-portal-Center-lr',
        label: '居中对齐',
        value: 'center',
      }, {
        iconClass: 'icon-portal-Align-right',
        label: '右对齐',
        value: 'right'
      }]
    }
  },
  {
    name: "navSite",
    desc: "排列",
    group: "默认",
    categoryName: "导航",
    type: "cxSite",
    defaultValue: {
      alignmentType: "center"
    }
  },
  {
    name: "navSize",
    desc: "尺寸",
    group: "默认",
    categoryName: "导航",
    type: "sizeSet",
    defaultValue: {
      widthVal: 500,
      heightVal: 300,
      widthAuto: true,
      heightAuto: true,
      widthFull: false
    }
  },
  {
    name: "wholeBackground",
    desc: "背景",
    isSystem: true,
    group: "默认",
    categoryName: "导航",
    type: "backgroundSet",
    defaultValue: [
      {
        type: "color",
        color: "#fff",
        isThemeColor: false
      }
    ]
  },
  {
    name: "secondNavIcon",
    desc: "图标",
    isSystem: true,
    group: "默认",
    categoryName: "导航",
    type: "iconSet",
    defaultValue: {
      ...defaultIconSetting,
    }
  },
  {
    name: "navBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    type: "borderSet",
    categoryName: "导航",
    defaultValue: {
      borderStyle: "solid",
      borderWidth: [0, 0, 0, 0],
      borderColor: "rgba(10, 107, 255, 1)"
    }
  },
  {
    name: "navPadding",
    desc: "边距",
    isSystem: true,
    group: "默认",
    type: "paddingSet",
    categoryName: "导航",
    defaultValue: {
      ...defaultPaddingSetting,
      padding: 10
    }
  },
  {
    name: "navBorderRadius",
    desc: "圆角",
    isSystem: true,
    group: "默认",
    type: "radiusSet",
    categoryName: "导航",
    defaultValue: {
      ...defaultBorderRadiusSetting
    }
  },
  {
    name: "navBoxShadow",
    desc: "阴影",
    isSystem: true,
    categoryName: "导航",
    group: "默认",
    type: "shadowSet",
    defaultValue: {
      ...defaultBoxShadowSetting
    }
  },
  {
    name: "connectorSet",
    desc: "连接符",
    isSystem: true,
    group: "默认",
    categoryName: "导航",
    type: "connectorSet",
    defaultValue: {
      showConnector:false,
      connectorWidth: 0,
      connectorColor: {
        type: 'color',
        color: 'rgba(10, 107, 255, 1)',
        isThemeColor: true,
        data: {
          angle: 0,
          stops: [
            ['rgba(10, 107, 255, 1)', 0],
            ['rgba(10, 107, 255, 1)', 1]
          ]
        }
      }
    },
  },
  {
    name: "coverSize",
    desc: "尺寸",
    isSystem: true,
    group: "默认",
    categoryName: "封面",
    type: "sizeSet",
    defaultValue: {
      widthVal: 148,
      widthAuto: false,
      widthFull: false,
      heightVal: 148,
      heightAuto: false
    }
  },
  {
    name: 'coverPadding',
    desc: '边距',
    categoryName: '封面',
    group: '默认',
    type: 'paddingSet',
    defaultValue: {
      ...defaultPaddingSetting
    }
  },
  {
    name: 'coverBorder',
    desc: '边框',
    categoryName: '封面',
    group: '默认',
    type: 'borderSet',
    defaultValue: {
      ...defaultBorderSetting,
    }
  },
  {
    name: 'coverShadow',
    desc: '阴影',
    categoryName: '封面',
    group: '默认',
    type: 'shadowSet',
    defaultValue: {
      ...defaultBoxShadowSetting,
    }
  },
  {
    name: 'coverRadius',
    desc: '圆角',
    categoryName: '封面',
    group: '默认',
    type: 'radiusSet',
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "descSize",
    desc: "尺寸",
    isSystem: true,
    group: "默认",
    categoryName: "简介",
    type: "sizeSet",
    defaultValue: {
      widthVal: 200,
      widthAuto: false,
      widthFull: false,
      heightVal: 0,
      heightAuto: true
    }
  },
  {
    name: "descFont",
    desc: "字体",
    isSystem: true,
    group: "默认",
    categoryName: "简介",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)",
      fontSize: 14
    }
  },
  {
    name: 'descPadding',
    desc: '边距',
    categoryName: '简介',
    group: '默认',
    type: 'paddingSet',
    defaultValue: {
      ...defaultPaddingSetting,
      paddingTypeFlag: 2,
      paddingLeft: 15
    }
  },
  {
    name: 'descBorder',
    desc: '边框',
    categoryName: '简介',
    group: '默认',
    type: 'borderSet',
    defaultValue: {
      ...defaultBorderSetting,
    }
  },
  {
    name: 'descShadow',
    desc: '阴影',
    categoryName: '简介',
    group: '默认',
    type: 'shadowSet',
    defaultValue: {
      ...defaultBoxShadowSetting,
    }
  },
  {
    name: "titleFont",
    desc: "字体",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(0, 0, 0, 1)",
      lineHeight: 40
    }
  },
  {
    name: "cols",
    desc: "列数",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "numberSet",
    defaultValue: 3,
    extraConfig: {
      slideMin: 1,
      slideMax: 100,
    }
  },
  {
    name: "colWidth",
    desc: "列宽",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "numberSet",
    defaultValue: 150,
    unit: "px",
    extraConfig: {
      sliderMin: 1,
      sliderMax: 300,
    }
  },
  {
    name: "rowGap",
    desc: "行间距",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      sliderMin: 0,
      sliderMax: 100,
    }
  },
  {
    name: "colGap",
    desc: "列间距",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "numberSet",
    defaultValue: 0,
    unit: "px",
    extraConfig: {
      sliderMin: 0,
      sliderMax: 100,
    }
  },
  {
    name: "titleBorder",
    desc: "边框",
    isSystem: true,
    group: "默认",
    categoryName: "标题",
    type: "borderSet",
    defaultValue: {
      ...defaultBorderSetting
    }
  },
  {
    name: 'titleBoxShadow',
    desc: '阴影',
    categoryName: '标题',
    group: '默认',
    type: 'shadowSet',
    defaultValue: {
      ...defaultBoxShadowSetting,
    }
  },
  {
    name: 'titleRadius',
    desc: '圆角',
    categoryName: '标题',
    group: '默认',
    type: 'radiusSet',
    defaultValue: {
      ...defaultBorderRadiusSetting,
    }
  },
  {
    name: "titleActiveFont",
    desc: "字体",
    isSystem: true,
    group: "选中",
    categoryName: "标题",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)",
      lineHeight: 40
    }
  },
  {
    name: 'titleActiveRadius',
    desc: '圆角',
    categoryName: '标题',
    group: '选中',
    type: 'radiusSet',
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 4
    }
  },
  {
    name: 'titleActiveBackground',
    desc: '背景',
    categoryName: '标题',
    group: '选中',
    type: 'backgroundSet',
    defaultValue: [{
      type: "color",
      color: "rgba(171,207,242,1)",
      isThemeColor: false
    }]
  },
  {
    name: "titleHoverFont",
    desc: "字体",
    isSystem: true,
    group: "悬浮",
    categoryName: "标题",
    type: "fontSet",
    defaultValue: {
      ...defaultFontSetting,
      fontColor: "rgba(10, 107, 255, 1)",
      lineHeight: 40
    }
  },
  {
    name: 'titleHoverRadius',
    desc: '圆角',
    categoryName: '标题',
    group: '悬浮',
    type: 'radiusSet',
    defaultValue: {
      ...defaultBorderRadiusSetting,
      borderRadius: 4
    }
  },
  {
    name: 'titleHoverBackground',
    desc: '背景',
    categoryName: '标题',
    group: '悬浮',
    type: 'backgroundSet',
    defaultValue: [{
      type: "color",
      color: "rgba(171,207,242,1)",
      isThemeColor: false
    }]
  },
]

export default props
